import styled from 'styled-components';
import { rem } from 'polished';
import WidgetBox from '../../WidgetList/WidgetBox';

const StyledWidgetBox = styled(WidgetBox)`
  background-color: transparent;
  padding: 0;

  .BoxApps {
    background-color: transparent;
  }

  .WidgetBox-title {
    background-color: transparent;
    color: ${props => props.theme.colors.light};
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('17px')};
    letter-spacing: 0.5;
    margin-left: 0;
    padding-left: ${rem('27px')};
    cursor: default;
    line-height: ${rem('20px')};
    display: flex;
    align-items: center;

    & > svg {
      fill: ${props => props.theme.colors.light};
      width: ${rem('18px')};
      height: ${rem('19px')};
      top: ${rem('5px')};
      left: ${rem('1px')};
    }
  }
  .ListBox {
    display: none;
  }
  .App-icon {
    fill: ${props => props.theme.colors.light};
    width: ${rem('40px')};
  }
  .App-text {
    color: ${props => props.theme.colors.light};
  }
`;

export { StyledWidgetBox };
